module.exports = __webpack_public_path__ + "images/film-buff-353e7aaddc63ea64b644505ca5528fd3.png";